import { writable } from 'svelte/store'
import { config } from '../config.js'
import { get, post, del } from '../services/http.js'

function createPayments() {
  const { subscribe, set, update } = writable({ methods: [], error: null})

  let detachPaymentMethod = async function (id) {
  }

  return {
    subscribe,

    loadMethods: async () => {
      let url = `${config.apiUrl}/account/payments/list`
      let methods = await get(url)
      if (methods){
        update((p) => {
          p.methods = methods;
          return p;
        });
      }
    },

    getSetupIntent: async () => {
      let url = `${config.apiUrl}/account/payments`
      let data = JSON.stringify({})
      return await post(url, data)
    },

    deleteMethod: async (id) => {
      let url = `${config.apiUrl}/account/payments`;
      let data = JSON.stringify({ id });
      let resp = await del(url, data);
      if (resp && resp.error) {
        update((p) => {
          p.error = resp.error;
          return p
        })
      } else {
        update((p) => {
          p.methods = p.methods.filter(x => x.id !== id);
          return p
        })
      }
    },

    replaceMethod: async (id) => {
        let url = `${config.apiUrl}/account/payments/list`
        let methods = await get(url)
        if (methods){
          update((p) => {
            p.methods = methods;
            return p;
          });
        }
    }
  }
}

export let payments = createPayments()
